import { gql } from '@apollo/client'

export default gql(`
    mutation deleteMediaCategories($id: [ID]! $project: String) {
        deleteMediaCategories(
            input: $id
            project: $project
        )
    }`
)
